module.exports = __webpack_public_path__ + "static/media/open-builder-1.8147eefb.png";